import ModelLoader from 'app/scripts/db/model-loader.coffee';
import ModelCache from 'app/scripts/db/model-cache.coffee';

export const fireAndForgetExtraBoardDataLoad = (idBoardOrShortLink: string) => {
  const loadSecondary = ModelLoader.for(
    'top-level',
    'loadBoardSecondary',
    idBoardOrShortLink,
  );
  const loadPluginData = ModelLoader.for(
    'top-level',
    'loadBoardPluginData',
    idBoardOrShortLink,
  );

  return Promise.all([loadSecondary, loadPluginData]);
};

interface LoadBoardDataOptions {
  loadLabels?: boolean;
  loadExtraBoardData?: boolean;
}

export const loadBoardData = async (
  idBoardOrShortLink: string,
  { loadLabels, loadExtraBoardData }: LoadBoardDataOptions = {},
) => {
  let requiredDataPromise;

  if (loadLabels) {
    requiredDataPromise = ModelLoader.for(
      'top-level',
      'loadCurrentBoardWithLabelData',
      idBoardOrShortLink,
    );
  } else {
    requiredDataPromise = ModelLoader.for(
      'top-level',
      'loadCurrentBoardData',
      idBoardOrShortLink,
    );
  }

  if (loadExtraBoardData) {
    fireAndForgetExtraBoardDataLoad(idBoardOrShortLink);
  }

  return requiredDataPromise;
};

export const getOrLoadCardData = async (idCardOrShortLink: string) => {
  const card = ModelCache.get('Card', idCardOrShortLink);
  if (card) {
    return card;
  }

  return ModelLoader.for('top-level', 'loadCardData', idCardOrShortLink);
};
